import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cwr-dynamic-message-box',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './dynamic-message-box.component.html',
    styleUrls: ['dynamic-message-box.component.scss'],
})
export class DynamicMessageBoxComponent implements OnInit {
    @Input() title?: string;
    @Input() message?: string;
    @Input() confirmText = 'OK';
    @Input() cancelText = 'Cancel';
    @Input() confirmButtonClass = 'btn btn-primary';
    @Input() cancelButtonClass = 'btn btn-secondary';
    @Input() confirmLast = false;
    @Input() hideCancel = false;
    @Input() onConfirm?: () => void;

    constructor(public activeModal: NgbActiveModal) {}
    ngOnInit() {}

    confirmOk() {
        if (this.onConfirm) {
            this.onConfirm();
        }
        this.activeModal.close();
    }

    dismiss() {
        this.activeModal.dismiss();
    }
}
